// logger positions along a pipe network: valves / hydrants first, spacing by material (metal carries noise far, plastic damps it)
import { pipeLatLngs } from './model';
import { geoDist } from './geo';

export const SPACING = { metal: 300, plastic: 100, other: 200 };
// quiet night measurement: less background noise -> loggers hear further
export const NIGHT = { metal: 500, plastic: 150, other: 300 };
const ATTACH = ['hydrant', 'valve', 'air', 'drain'];
const RANK = { hydrant: 0, valve: 1, air: 2, drain: 3 };
export const matClass = (m = '') => (/PE|PVC|PP|kunst|plast/i.test(m) ? 'plastic' : /GG|guss|cast|duct|st(ahl)?\b|steel|iron|ghisa|acciaio|fonte|fundi/i.test(m) ? 'metal' : 'other');
const diam = (p) => p.hyd?.d || +(String(p.dn || '').match(/\d+/)?.[0] || 0);
const isMain = (p) => !/sewer|gas|cable|house/.test(p.type || '') && !(diam(p) && diam(p) < 50);
const inBox = (b, [la, lo]) => !b || (la >= b[0] && la <= b[2] && lo >= b[1] && lo <= b[3]);

export function suggestLoggers(project, box = null, spacing = SPACING) {
  const F = project.fittings || [], pipes = (project.pipes || []).filter(isMain), byId = new Map(F.map((f) => [f.id, f]));
  const sp = new Map(); // fitting id -> tightest spacing of its pipes
  const lines = pipes.map((p) => {
    const s = +spacing[matClass(p.material)] || SPACING[matClass(p.material)], pts = pipeLatLngs(p, F);
    p.points.forEach((pt) => pt.fid && sp.set(pt.fid, Math.min(sp.get(pt.fid) ?? s, s)));
    return { p, s, pts };
  });
  const picked = [], far = (q, s) => picked.every((x) => geoDist(x.at, q) >= Math.min(s, x.s) * 0.8);
  // 1) fittings on the mains, hydrants before valves
  F.filter((f) => ATTACH.includes(f.type) && sp.has(f.id) && inBox(box, [f.lat, f.lon])).sort((a, b) => RANK[a.type] - RANK[b.type])
    .forEach((f) => { const s = sp.get(f.id), at = [f.lat, f.lon]; if (far(at, s)) picked.push({ at, s, fid: f.id, kind: f.type, name: f.name || '' }); });
  // 2) gaps: points along the pipe farther than one spacing from every logger (no fitting there)
  for (const { p, s, pts } of lines) {
    for (let i = 1; i < pts.length; i += 1) {
      const n = Math.max(1, Math.ceil(geoDist(pts[i - 1], pts[i]) / (s / 2)));
      for (let k = 0; k <= n; k += 1) {
        const q = [pts[i - 1][0] + ((pts[i][0] - pts[i - 1][0]) * k) / n, pts[i - 1][1] + ((pts[i][1] - pts[i - 1][1]) * k) / n];
        if (inBox(box, q) && picked.every((x) => geoDist(x.at, q) > Math.min(s, x.s))) picked.push({ at: q, s, fid: null, kind: 'gap', name: p.name || '' });
      }
    }
  }
  return picked.map((x, i) => ({ id: `sg${i}`, lat: x.at[0], lon: x.at[1], kind: x.kind, name: x.name, spacing: x.s, fid: x.fid, fitting: x.fid ? byId.get(x.fid) : null }));
}
